const scrollPosition = state => state.scrollPosition

export default {
    scrollPosition
}
